var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons_16px"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Line 202 (Stroke)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.99916 3L8.99916 15L6.99917 15L6.99917 3L8.99916 3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99118 0.93175L3.75 5.17293L5.16419 6.58717L7.99118 3.76018L10.8182 6.58722L12.2324 5.17301L7.99118 0.93175Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortUp);
export default __webpack_public_path__ + "static/media/SortUp.85a6eaf4c4b8b9b8eb91985d987e1b22.svg";
export { ForwardRef as ReactComponent };